import axios, { InternalAxiosRequestConfig, AxiosError , AxiosResponse } from 'axios';

const Http = axios.create();

const { REACT_APP_AUTH_SERVER_BASE_URL } = process.env;

class Service {
  protected static Http = Http;
  protected static getData = getData;

  public static setRequestInterceptors(
    onFulfilled: (
      request: InternalAxiosRequestConfig
    ) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>,
    onRejected?: (error: AxiosError) => any
  ){
    ;
    Http.interceptors.request.use(onFulfilled, onRejected);
  }  

  public static setResponseInterceptors (
    onFulfilled:(
      response: AxiosResponse
    )=> AxiosResponse | Promise<AxiosResponse>,
    onRejected: (error: any) => any
  ){
    Http.interceptors.response.use(onFulfilled, onRejected);
  }  
}

function getData<T>(res: AxiosResponse<T>) {
  return res.data;
}

Http.defaults.baseURL = REACT_APP_AUTH_SERVER_BASE_URL;

export default Service;
